//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { faBolt, faSparkle } from '@fortawesome/pro-solid-svg-icons';
import featureFlagMixin from '../mixins/feature-flag.mixin.js';
import studioAiMixin from '../mixins/studio-ai.mixin.js';
import { publishedContentCounts, renderContentCount } from '../../helpers/contentCount.js';

export default {
  name: 'explore-menu',
  mixins: [featureFlagMixin, studioAiMixin],
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    NavLink: () => import('./NavLink.vue'),
    ChannelsMenu: () => import('./MediaTypesMenu.vue'),
  },
  data() {
    return {
      faBolt,
      faSparkle,
      subscriptionTextCount: renderContentCount(this, publishedContentCounts.total.subscription.element),
      subscribeDogImg: 'https://static.moele.me/img/channels2022/subscribe-dog-220815.png?auto=format&w=582',
      subscribeDogImgMobile: 'https://static.moele.me/img/channels2022/subscribe-dog-mobile-220815.png?auto=format&w=364',
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
    ...mapGetters({
      isContributor: 'user/isArtist',
      hasUnlimitedSubscription: 'user/hasUnlimitedSubscription',
    }),
    contributorsHeroImg() {
      if (['ja', 'zh-hant'].includes(this.$i18n.locale)) {
        return 'https://static.moele.me/img/channels2022/contributors-signup-hero-ja-220815.png?auto=format&w=775';
      }
      return 'https://static.moele.me/img/channels2022/contributors-signup-hero-220815.png?auto=format&w=775';
    },
    showUnlimitedSubscriptionLink() {
      return !this.isContributor && !this.hasUnlimitedSubscription;
    },
  },
};
